import type { NewAuditForm } from "./types";

// ─── Trigger Options ───────────────────────────────────────────────────────

export const TRIGGER_OPTIONS = [
  "Regulatory",
  "Certification",
  "Internal",
  "Ad-hoc",
] as const;

export const TRIGGER_LABEL_KEYS = {
  Regulatory: "wizard.triggers.regulatory",
  Certification: "wizard.triggers.certification",
  Internal: "wizard.triggers.internal",
  "Ad-hoc": "wizard.triggers.adHoc",
} as const satisfies Record<
  (typeof TRIGGER_OPTIONS)[number],
  | "wizard.triggers.regulatory"
  | "wizard.triggers.certification"
  | "wizard.triggers.internal"
  | "wizard.triggers.adHoc"
>;

// ─── Default Form Values ───────────────────────────────────────────────────

export function getDefaultFormValues(): NewAuditForm {
  return {
    templateId: "",
    workspaceAuditTypeId: "",
    displayName: "",
    description: "",
    trigger: "",
    deadline: "",
    tagIds: [],
    auditorRequestText: "",
    notes: "",
    checklistSource: "official",
    depthTier: null,
    profilingAnswers: null,
    orgContext: null,
    piiRole: null,
  };
}
